module.exports = __webpack_public_path__ + "public/img/changePrice.70eb4844.png";